import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { Category, CategoryMenuNode } from 'types/category';

const mapCategory = (item: Category): Category => ({
  ...item,
  id: item.id || item.code || item.slug,
  children: item.children?.map(mapCategory),
});

const categoryService = {
  getCategories: async (levels?: string): Promise<Category[]> => {
    const response = await api.get<Category[]>(ENDPOINTS.CATEGORIES, {
      params: levels ? { levels } : undefined,
    });
    return Array.isArray(response.data) ? response.data.map(mapCategory) : [];
  },

  getCategoryMenu: async (): Promise<CategoryMenuNode[]> => {
    const response = await api.get<CategoryMenuNode[]>(ENDPOINTS.CATEGORY_MENU);
    return Array.isArray(response.data) ? response.data : [];
  },

  getCategoryBySlug: async (slug: string, source?: string): Promise<Category> => {
    const response = await api.get<Category>(ENDPOINTS.CATEGORY_BY_SLUG(slug), {
      params: source ? { source } : undefined,
    });
    return mapCategory(response.data);
  },
};

export default categoryService;
